
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { IPickerModel } from '@rhybus/api'
import React, { createContext, useEffect, useState } from 'react'

import { APP_NAME,CLIENT_CODE,RHYBUS_ACCESS_TOKEN } from '../Configuration'
import { xsrfInitEffect } from '../assets/ts/api/api'
import { mpfRListsHttp } from '../assets/ts/api/mpf-r-lists-http'
import { UserProfile, getUserProfile } from '../assets/ts/data/user-profile'
import { loginRequest } from "../authConfig"

const INVALID_USER_ID = '00000000-0000-0000-0000-000000000000'

const UserInitalValue = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  me: null as any,
  multiplePopup: '',
  setMultiplePopup: (s?) => {
    console.error('stub', s)
  },
  setUserProfile: (p) => {
    console.error('stub', p)
  },
  userId: INVALID_USER_ID,
  userProfile: [] as UserProfile[],
  userProfileIsLoading: true,
}
const UserContext = createContext(UserInitalValue)
const UserContextProvider: React.FC = ({ children }) => {
  const [multiplePopup, setMultiplePopup] = useState<string>('')
  const [me, setMe] = useState<IPickerModel>()
  const [userId, setUserId] = useState(INVALID_USER_ID)
  const [userProfile, setUserProfile] = useState<UserProfile[]>([])
  const [userProfileIsLoading, setUserProfileIsLoading] = useState(true)
  const { accounts, instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()
 
  useEffect(() => {
    try {
    const rhybusAccessToken = async () => {
    if (isAuthenticated && accounts.length > 0) {     
      await instance
        .acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
        })
        .then((response) => {
          localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
          localStorage.setItem(RHYBUS_ACCESS_TOKEN, response.accessToken)
          localStorage.setItem(CLIENT_CODE,APP_NAME)
          doStart()
          }
        )
    }
  }
  rhybusAccessToken()
}
catch (error) {
  if (error instanceof InteractionRequiredAuthError) {
    // Token expired or no valid token, trigger re-authentication
    console.log('Token expired, requiring re-authentication...')
    instance.acquireTokenPopup(loginRequest).then(
      (response) => {
        console.log('New access token:', response.accessToken)
      },
      (error) => {
        console.error('Authentication failed:', error)
      }
    )
  } else {
    console.error('Token acquisition failed:', error)
  }
}
  }, [isAuthenticated, accounts])

    async function doStart() {
      setUserProfileIsLoading(true)
      
        const meValue = await mpfRListsHttp().me()
        meValue.persona = meValue?.firstName + ' ' + meValue?.lastName
        meValue.rid = meValue.userId
        const profile = await getUserProfile({ userRID: meValue.rid })
        setMe(meValue)
        setUserId(meValue?.rid ?? INVALID_USER_ID)
        setUserProfile(profile)
        setUserProfileIsLoading(false)
    }
  

  return (
    <UserContext.Provider
      value={{
        me,
        multiplePopup,
        setMultiplePopup,
        setUserProfile,
        userId,
        userProfile,
        userProfileIsLoading,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export { UserContext, UserContextProvider, UserInitalValue }
